export const FORECAST_REGISTER_TBL_HEAD = [
  {
    field: 'course_enrollment_id',
    headerName: 'Enrollment ID',
    width: 140,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'admn_no',
    headerName: 'Admission No',
    width: 140,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'student_name',
    headerName: 'Student Name',
    width: 180,
    sortable: true,
  },

  {
    field: 'email',
    headerName: 'Email',
    width: 200,
    valueGetter: (params) => params.row.email || '-',
  },
  {
    field: 'phone',
    headerName: 'Phone',
    width: 150,
  },
  {
    field: 'course_name',
    headerName: 'Course',
    width: 250,
    sortable: true,
  },

  // ✅ Status with valueGetter
  {
    field: 'course_enrollment_status',
    headerName: 'Status',
    width: 170,
    align: 'center',
    headerAlign: 'center',
    valueGetter: (params) => {
      const value = params.row.course_enrollment_status;
      if (value === 1) return 'Active';
      if (value === 2) return 'Temporarily Inactive';
      return 'Inactive';
    },
    sortable: true,
  },

  {
    field: 'cro_name',
    headerName: 'CRO',
    width: 170,
    sortable: true,
  },
  {
    field: 'oga_name',
    headerName: 'OGA',
    width: 170,
    sortable: true,
  },

  {
    field: 'course_enrollment_timestamp',
    headerName: 'Enrollment Date',
    width: 170,
    sortable: true,
  },

  // 💰 Pricing
  {
    field: 'cart_item_mrp',
    headerName: 'MRP',
    width: 120,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },
  {
    field: 'cart_item_discount',
    headerName: 'Discount',
    width: 120,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },
  {
    field: 'saleAmt',
    headerName: 'Sale Amount',
    width: 130,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },
  {
    field: 'income_amount',
    headerName: 'Collected Fee (INR)',
    width: 170,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },
  {
    field: 'income_amount_aed',
    headerName: 'Collected Fee (AED)',
    width: 170,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },

  // ✅ Currency using valueGetter
  {
    field: 'currency_type',
    headerName: 'Currency',
    width: 130,
    align: 'center',
    headerAlign: 'center',
    valueGetter: (params) => {
      const value = params.row.currency_type;
      if (value === 1) return 'INR';
      if (value === 2) return 'AED';
      if (value === 3) return 'AED to INR';
      return 'INR';
    },
    sortable: true,
  },

  // 💵 Income

  // 📊 Academic
  {
    field: 'subjects_count',
    headerName: 'Subjects',
    width: 110,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'total_sessions_all_subjects',
    headerName: 'Total Sessions',
    width: 140,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'total_classes_taken',
    headerName: 'Classes Taken',
    width: 140,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'total_weekly_classes',
    headerName: 'Weekly Classes',
    width: 130,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'is_calendar_created',
    headerName: 'Calendar Created',
    width: 160,
    align: 'center',
    headerAlign: 'center',
    valueGetter: (params) => (params.row.is_calendar_created ? 'Yes' : 'No'),
    sortable: true,
  },
  {
    field: 'current_month_expected_sessions',
    headerName: 'Scheduled Sessions',
    width: 200,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },

  {
    field: 'peak_classes_taken',
    headerName: 'Peak Classes',
    width: 130,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },

  // 🔮 Forecast Section

  {
    field: 'is_forecast_created',
    headerName: 'Forecast Created',
    width: 160,
    align: 'center',
    headerAlign: 'center',
    valueGetter: (params) => (params.row.is_forecast_created ? 'Yes' : 'No'),
  },
  {
    field: 'forecast_type',
    headerName: 'Forecast Type',
    width: 140,
    align: 'center',
    headerAlign: 'center',
    valueGetter: (params) =>
      params.row.forecast_type == 1 ? 'Options' : params.row.forecast_type == 2 ? 'Percentage' : 'Manual',
    sortable: true,
  },
  {
    field: 'amount_to_collect',
    headerName: 'Amount to Collect',
    width: 170,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },
];
